interface Bounds {
  top: number;
  bottom: number;
}

export interface ShouldFlipUpParams {
  anchor: Bounds;
  panel: Bounds;
  boundary: Bounds;
}

export const shouldFlipUp = ({ anchor, panel, boundary }: ShouldFlipUpParams): boolean => {
  const spaceBelow = boundary.bottom - panel.top;
  const spaceAbove = anchor.top - boundary.top;

  if (spaceBelow >= panel.bottom - panel.top) {
    return false;
  }
  return spaceAbove > spaceBelow;
};
